import { formatPercentage } from "~/utils/helpers";

import { useMediaPlayerContext } from "./context";

export interface MediaProgressBufferedProps {
  end?: number;
  start?: number;
}

export function MediaProgressBuffered({
  end,
  start,
}: MediaProgressBufferedProps) {
  const { buffered, duration, currentTime } = useMediaPlayerContext();

  if (!buffered || !buffered.length) {
    return null;
  }

  let bufferedMax = 0;

  for (let i = 0; i < buffered.length; i++) {
    // Discard buffered ranges that start after the
    // currentTime. This means that only the next immediate
    // buffered range (and lower) is displayed
    if (buffered.start(i) > currentTime) continue;

    bufferedMax = buffered.end(i);
  }

  // Don't render anything if the range start is greater
  // than the highest buffered range
  if (start && start > bufferedMax) return null;

  if (bufferedMax > duration) {
    bufferedMax = duration;
  }

  return (
    <div
      className="MediaProgressBuffered"
      style={{
        width: formatPercentage(bufferedMax, end ?? duration),
      }}
    />
  );
}
